var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnExcelDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CECDD1",
    fillRule: "evenodd",
    d: "M15.4,24 L0,20 L0,4 L15.4,0 L15.4,24 Z M6.2975,6.66667 L3.85,6.66667 L6.3525,10.9867 L3.685,15.8933 L6.0775,15.8933 L7.6725,12.3733 L9.295,15.8933 L11.7425,15.8933 L8.9925,10.9067 L11.495,6.66667 L9.1025,6.66667 L7.6725,9.62667 L6.2975,6.66667 Z M16.5,4 L22,4 L22,20 L16.5,20 L16.5,4 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnExcelDisabled);
export default __webpack_public_path__ + "static/media/icn-excel-disabled.4d64a3ff.svg";
export { ForwardRef as ReactComponent };